import { render, staticRenderFns } from "./FiltroPesquisaReservados.vue?vue&type=template&id=056ad512&scoped=true"
import script from "./FiltroPesquisaReservados.vue?vue&type=script&lang=js"
export * from "./FiltroPesquisaReservados.vue?vue&type=script&lang=js"
import style0 from "./FiltroPesquisaReservados.vue?vue&type=style&index=0&id=056ad512&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056ad512",
  null
  
)

export default component.exports